module.exports = __webpack_public_path__ + "img/c7c8231b88aa29a056e1b02a3e48dd28.png";